<div class="content-card">
  <app-delegation-cost-basic-info
    [delegationBasicInfoFormGroup]="delegationBasicInfoFormGroup"
    [delegationCorrectionComment]="delegationCorrectionComment"
  ></app-delegation-cost-basic-info>

  <div class="content-card">
    <h2 class="content-card__header">{{ 'DMF-DelegationMileage' | translate }}</h2>

    @if (canEdit) {
    <div fxLayout="row" fxLayoutAlign="start center">
      <button id="delegation-mileage-step-add-button" mat-raised-button color="primary" (click)="openMileageModal()">{{ 'DCF-AddCost' | translate }}</button>
    </div>
    }
  </div>

  <app-delegation-mileage-list
    [delegationId]="delegationId"
    [canEdit]="canEdit"
    [startDate]="startDate"
    [endDate]="endDate"
  ></app-delegation-mileage-list>

  <div class="header-wrapper"></div>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <button id="delegation-mileage-step-back-button" mat-raised-button color="accent" matStepperPrevious>
      <mat-icon>arrow_back</mat-icon>
      {{ 'Back' | translate }}
    </button>
    <button id="delegation-mileage-step-next-button" mat-raised-button color="primary" matStepperNext>{{ 'Next' | translate }}</button>
  </div>
</div>
